import { XmlRules } from '../xml-rules-check/xmlRules.class';
import { Xml2html } from './xml2html.class';
import { XmlToolbox } from '../xmlToolbox.class';
import { Xml2htmlAttributeWorker } from './xml2htmlAttributeWorker.class';
import { DomDummyNodeManager } from '../dummyNodes/domDummyNodeManager.class';

export class Html2xml {
  private attributeWorker: Xml2htmlAttributeWorker;

  constructor(public rules: XmlRules) {
    this.attributeWorker = new Xml2htmlAttributeWorker(rules);
  }

  public ToXml(html: string): string {
    if (html === '') {
      return '';
    }
    // html = html.replace('\t', '');
    // html = html.replace('\r', '');
    // html = html.replace('\n', '');

    const cleanHtml = this.CleanUpHtmlBeforeConvert2Xml(html);
    const domparser = new DOMParser();
    const domdoc = domparser.parseFromString(cleanHtml, 'text/xml');
    const targetDocument = new Document();
    if (domdoc.documentElement === null) {
      return '';
    }

    const body = this.GetXmlElementFromHtmlElement(domdoc.documentElement, targetDocument);
    if (body && body.nodeType === Node.ELEMENT_NODE) {
      const xml = (body as Element).outerHTML;
      return xml;
    } else {
      throw new Error(`root node ${XmlToolbox.GetNodeDebugContext(body)} is no element`);
    }
  }

  private CleanUpHtmlBeforeConvert2Xml(html: string): string {
    const domparser = new DOMParser();
    const domdoc = domparser.parseFromString(html, 'text/html');
    new DomDummyNodeManager().RemoveAllDummyNodes(domdoc.documentElement); // remove all dummy nodes
    const cleanHtml = domdoc.body.innerHTML;
    return cleanHtml;
  }

  private GetXmlElementFromHtmlElement(node: Node, targetDocument: Document): Node {
    switch (node.nodeType) {
      case Node.ELEMENT_NODE: // element node
        const asElement = node as Element;
        const tagName = Xml2html.getTagNameFromNode(node);

        if (!tagName || tagName === '') {
          throw new Error(`no tagname in ${XmlToolbox.GetNodeDebugContext(node)}`);
        }

        // create element node
        const newElement = targetDocument.createElement(tagName);

        // append child elements recursive
        const children = asElement.childNodes;
        if (children.length === 0 && !asElement.classList.contains(Xml2html.NoClosingTagClassName)) {
          newElement.appendChild(targetDocument.createTextNode('')); // to prevent non closing tags
        } else {
          for (let i = 0; i < children.length; ++i) {
            const childAsHtml = this.GetXmlElementFromHtmlElement(children[i], targetDocument);
            if (childAsHtml !== undefined) {
              newElement.appendChild(childAsHtml);
            }
          }
        }

        // // insert attributes
        this.attributeWorker.writeAllHtmlAttributesToXml(asElement, newElement);

        return newElement;

      case Node.TEXT_NODE: // text node
        const content = (node as Element).textContent;
        if (content.length > 0) {
          return targetDocument.createTextNode(content);
        } else {
          return undefined;
        }

      default:
        // tslint:disable-next-line:max-line-length
        throw new Error(`unknown html element nodeType ${node.nodeType} in value: ${XmlToolbox.GetNodeDebugContext(node)}`);
    }
  }
}
